import React, { PureComponent } from 'react';
import { Accordion, AccordionItem } from '@dbk/ui-accordion';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { Large, Small } from '@dbk/ui-text';
import SimpleDate from '../../../components/common/date';
import PdfStatement from '../pdf-statements';
import { NavigationList, NavigationListItem, NavigationListItemHeader, NavigationListItemFooter } from '@dbk/ui-list';
import FullMonthYear from '../../../components/common/fullMonth-Year';
import format from 'date-fns/format';
class ReportStatement extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            selectedMonth: 'January',
            pdfListData: '',
        };
        this.handlePress = this.handlePress.bind(this);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.props.clearReports();
        this.setState({ pdfListData: '' });
    }

    capitalize(s) {
        if (s)
            return (
                s[0].toUpperCase().trim() +
                s
                    .slice(1)
                    .toLowerCase()
                    .trim()
            );
        return '';
    }

    handlePress(selectedObject) {
        const {
            changePage,
            i18n: { messages },
        } = this.props;
        let pagefrom = this.props.pagefrom;
        let outputType = '';
        setTimeout(() => {
            this.setState({ pdfListData: '' });
        }, 100);
        switch (this.props.pagefrom) {
            case 'monthly':
                outputType = 'portfolio';
                break;
            case 'currentlyMonthly':
                outputType = 'current';
                break;
            case 'advice':
                outputType = 'advices';
                break;
            case 'correspondence':
                outputType = 'correspondence';
                break;
            case 'daily':
                outputType = 'daily';
                break;
        }
        if (pagefrom === 'monthly' || pagefrom === 'currentlyMonthly') {
            this.setState({
                selectedMonth: this.capitalize(selectedObject.statementsMth),
            });
            setTimeout(() => {
                this.props.getMonthData({
                    selectedYear: this.props.selectedYear,
                    selectedMonth: this.capitalize(selectedObject.statementsMth),
                    outputType: outputType,
                    selectedItems: selectedObject.noOfStatements,
                    monthText: messages['app.reports.monthText'],
                });
            }, 100);
        }
        if (pagefrom === 'advice') {
            let adviceItem = {
                date: selectedObject.statementDates,
                outputType: outputType,
                item: selectedObject.noOfStatements,
            };
            this.props.advices.onAdvicePress({
                adviceItem,
            });
        }
        if (pagefrom === 'correspondence' || pagefrom === 'daily') {
            let selectedDate = {
                date: selectedObject.statementDates,
                outputType: outputType,
                selectedItems: selectedObject.noOfStatements,
            };
            setTimeout(() => {
                this.props.getDailyPdfList({ selectedDate });
            }, 100);
        }
    }

    translateMonth(month) {
        const {
            i18n: { messages },
        } = this.props;
        const translatedMonth = month.trim().substring(0, 3).toUpperCase();
        const oReturn = messages[translatedMonth];
        return oReturn;
    }

    _renderHeader(listItem, index) {
        const {
            i18n: { messages },
        } = this.props;
        let monthYr = '';
        if (listItem.statementsMth) {
            monthYr = this.translateMonth(listItem.statementsMth) + ' ' + this.props.selectedYear;
        }
        return (
            <NavigationListItem onClick={() => this.handlePress(listItem)}>
                <div>
                    <NavigationListItemHeader>
                        <Text secondary>
                            {(this.props.pagefrom === 'monthly' ||
                                this.props.pagefrom === 'currentlyMonthly') && (
                                    <Text secondary>{monthYr}</Text>
                                )}
                            {(this.props.pagefrom === 'advice' ||
                                this.props.pagefrom === 'correspondence' ||
                                this.props.pagefrom === 'daily') && (
                                    <SimpleDate value={listItem.statementDates} />
                                )}
                        </Text>
                    </NavigationListItemHeader>
                    <NavigationListItemFooter className="commonWidth">
                        <Small>
                            {listItem.noOfStatements} {messages['app.reports.common.items']}
                        </Small>
                    </NavigationListItemFooter>
                </div>
            </NavigationListItem>
        );
    }

    renderMonthsList(reportList) {
        const {
            i18n: { messages },
            monthly: { getMonthStatementList },
            advices: { selectedAdviceLists },
            dailyPdf: { dailyStatementsList },
        } = this.props;
        this.setState({ pdfListData: '' });
        let pdfList = '';
        switch (this.props.pagefrom) {
            case 'monthly':
                pdfList = getMonthStatementList;
                break;
            case 'currentlyMonthly':
                pdfList = getMonthStatementList;
                break;
            case 'advice':
                pdfList = selectedAdviceLists;
                break;
            case 'correspondence':
                pdfList = dailyStatementsList;
                break;
            case 'daily':
                pdfList = dailyStatementsList;
                break;
        }
        this.setState({ pdfListData: pdfList });
        if (reportList != undefined && reportList != null) {
            return reportList.map((listItem, index) => (
                <div >
                    <Accordion
                        // renderIconForOpen={ArrowUp}
                        // renderIconForClose={ArrowDown}
                        onChange={() => this.handlePress(listItem)}
                    >
                        <AccordionItem
                            itemKey={index}
                            key={index}
                            renderTitle={() => this._renderHeader(listItem, index)}
                            allowMultiple={false}
                        >
                            <div>
                                {this.state.pdfListData ? (
                                    <div>
                                        <PdfStatement pagefrom={this.props.pagefrom} />
                                    </div>
                                ) : (
                                        <div>
                                            <Large />
                                        </div>
                                    )}
                            </div>
                        </AccordionItem>
                    </Accordion>
                </div>
            ));
        } else {
            return (
                <div>
                    <Large>
                        {messages['app.reports.noRecords']}
                    </Large>
                </div>
            );
        }
    }

    renderMonthsListTablet(reportList) {
        const {
            i18n: { messages },
            monthly: { getMonthStatementList },
            advices: { selectedAdviceLists },
            dailyPdf: { dailyStatementsList },
        } = this.props;
        let pdfList = '';
        switch (this.props.pagefrom) {
            case 'monthly':
                pdfList = getMonthStatementList;
                break;
            case 'currentlyMonthly':
                pdfList = getMonthStatementList;
                break;
            case 'advice':
                pdfList = selectedAdviceLists;
                break;
            case 'correspondence':
                pdfList = dailyStatementsList;
                break;
            case 'daily':
                pdfList = dailyStatementsList;
                break;
        }
        this.setState({ pdfListData: pdfList });
        let customStylesreportList = this.state.pdfListData ? 'column large-7 medium-7' : ''
        if (reportList != undefined && reportList != null) {
            return (
                <div className="row">
                    <div className={customStylesreportList}>
                        {
                            reportList.map((listItem, index) => {
                                let monthYr = '';
                                if (listItem.statementsMth) {
                                    monthYr = listItem.statementsMth.trim() + '-' + this.props.selectedYear;
                                }
                                return (
                                    <NavigationList fullWidth >
                                        {this._renderHeader(listItem, index)}
                                    </NavigationList>
                                );
                            })
                        }
                    </div>
                    <div className="column large-5 medium-5">
                        {this.state.pdfListData ? (
                            <div>
                                <PdfStatement pagefrom={this.props.pagefrom} />
                            </div>
                        ) : (
                                <div>
                                    <Large />
                                </div>
                            )}
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <Large>
                        {messages['app.reports.noRecords']}
                    </Large>
                </div>
            );
        }
    }

    render() {
        return (
            <div>
                <div>
                    {this.renderMonthsListTablet(this.props.reportList)}
                </div>
            </div>
        );
    }
}

export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        app: {
            global: {
                deviceInfo: {
                    isTablet: true,
                    width: true,
                    height: true,
                },
            },
        },
        clearReports: { $call: 'report.clearData' },
        monthly: {
            getMonthStatementList: true,
        },
        getMonthData: {
            $call: 'monthly.getMonthStatement',
        },
        advices: {
            onAdvicePress: { $call: 'getSelectedAdviceItem' },
            selectedAdviceLists: true,
        },
        getDailyPdfList: {
            $call: 'daily.getPdfLists',
        },
        dailyPdf: {
            dailyStatementsList: true,
        },
    },
})(ReportStatement);
